import {
    reactive
} from 'vue'

export const storeAuth = reactive({
    isLogin: false,
    authToken: null,
    user: {
        full_name: null,
    }
})